export function wrapStringInHTML(str) {
  return {__html: str }
}